module.exports = __webpack_public_path__ + "img/composition@2x.1a266038.png";